var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1715743059178,
    className: "icon",
    viewBox: "0 0 1168 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 8885,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.75,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M930.484018 846.319635l-112.219178 126.246575-112.219178-126.246575h79.488585v-219.762557h65.461187v219.762557zM570.447489 210.410959H794.885845v65.461187h-224.438356z",
    "p-id": 8886,
    "data-spm-anchor-id": "a313x.search_index.0.i4.f6683a81Zs3pGP",
    className: "selected",
    fill: "#10a078"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219.762557 130.922374h640.584475v317.954338h60.785388V65.461187H154.30137v158.977169h65.461187z",
    "p-id": 8887,
    "data-spm-anchor-id": "a313x.search_index.0.i2.f6683a81Zs3pGP",
    className: "selected",
    fill: "#10a078"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M570.447489 336.657534H794.885845v65.461187h-224.438356zM570.447489 462.90411H794.885845v65.461187h-224.438356zM219.762557 799.561644H154.30137v158.977169h383.415525v-65.461187H219.762557zM28.054795 771.506849h509.6621v-514.337899H28.054795v514.337899z m144.949771-388.091324h93.515982l28.054794 56.109589 37.406393-56.109589h65.461187L327.305936 495.634703c4.675799 0 70.136986 144.949772 70.136986 144.949772h-93.515981l-28.054795-56.109589-42.082192 56.109589H173.004566l70.136987-112.219178-70.136987-144.949772z",
    "p-id": 8888,
    "data-spm-anchor-id": "a313x.search_index.0.i3.f6683a81Zs3pGP",
    className: "selected",
    fill: "#10a078"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/Excel下载.ef860b2d88fa148909c9ad70749287da.svg";
export { ForwardRef as ReactComponent };